// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    ValidateEmail,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { xRegex } from "@keller/XDL/Utilities";

type HandlerType = Handler<
    {
        isSubscribed?: boolean;
        billToId?: string;
        shipToId?: string;
        useDefaultCustomer?: boolean;
        email?: string;
        phone?: string;
        fulfillmentMethod?: string;
        defaultWarehouse?: WarehouseModel;
    },
    {
        emailErrorMessage?: string;
        phoneErrorMessage?: string;
    }
>;

export const SecoundValidateEmail: HandlerType = props => {
    const {
        parameter: { email },
    } = props;
    if (typeof email === "undefined") {
        return;
    }

    const requiredFieldMessage = siteMessage("Field_Required", translate("Email Address"));
    const emailFieldMessage = siteMessage("Field_Invalid", translate("Email Address"));

    const errorMessage = email === "" ? requiredFieldMessage : xRegex.email.test(email) ? "" : emailFieldMessage;
    props.emailErrorMessage = errorMessage as string;
};
export const ValidatePhone: HandlerType = props => {
    const {
        parameter: { phone },
    } = props;
    if (typeof phone === "undefined") {
        return;
    }

    const requiredFieldMessage = siteMessage("Field_Required", translate("Phone Number"));
    const phoneFieldMessage = siteMessage("Field_Invalid", translate("Phone Number"));

    const errorMessage = phone === "" ? requiredFieldMessage : xRegex.phone.test(phone) ? "" : phoneFieldMessage;
    props.phoneErrorMessage = errorMessage as string;
};

export const DispatchUpdatePhoneNumber: HandlerType = props => {
    const {
        parameter: { phone },
    } = props;
    if (typeof phone === "undefined") {
        return;
    }
    props.dispatch({
        type: "xAccountSettings/UpdatePhoneNumber",
        phoneErrorMessage: props.phoneErrorMessage,
        phone,
    } as any);
};

addToChainAfter(chain, ValidateEmail, SecoundValidateEmail);
addToChainAfter(chain, SecoundValidateEmail, ValidatePhone);
addToChainAfter(chain, ValidatePhone, DispatchUpdatePhoneNumber);
